import showElement from '../util/show-element';
import FetchError from '../util/fetch-error';

import Cookie from './cookie';

const config = {
  howManyToShow: 4,
  howManyToStoreInMemory: 10,
  wrapper: '[data-recently-viewed-products]',
  limit: 'data-limit',
  recentTabLink: '[data-recent-link-tab]',
  recentWrapper: '[data-recent-wrapper]',
  recentViewedTab: '[data-recently-viewed-tab]',
  tabsHolderScroll: '[data-tabs-holder-scroll]',
  apiContent: '[data-api-content]',
  dataMinimum: 'data-minimum',
};

const cookieConfig = {
  expires: 90,
  name: 'shopify_recently_viewed',
};

const sections = [];
const excludedHandles = [];

class RecentProducts {
  constructor(section) {
    this.container = section.container;
    this.cookie = new Cookie(cookieConfig);
    this.wrapper = this.container.querySelector(config.wrapper);

    if (this.wrapper === null) {
      return;
    }

    this.howManyToShow = parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.limit)) || config.howManyToShow;
    this.minimum = parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.dataMinimum));

    this.recentViewedTab = this.container.querySelector(config.recentViewedTab);
    this.recentViewedLink = this.container.querySelector(config.recentTabLink);
    this.tabsHolderScroll = this.container.querySelector(config.tabsHolderScroll);

    this.renderProducts();
  }

  renderProducts() {
    const recentlyViewedHandlesArray = this.cookie.read();
    const arrayURLs = [];
    let counter = 0;

    if (recentlyViewedHandlesArray.length > 0) {
      for (let index = 0; index < recentlyViewedHandlesArray.length; index++) {
        const handle = recentlyViewedHandlesArray[index];

        if (excludedHandles.includes(handle)) {
          continue;
        }

        const url = `${window.theme.routes.root_url}products/${handle}?section_id=api-product-grid-item`;

        arrayURLs.push(url);

        counter++;

        if (counter === this.howManyToShow || counter === recentlyViewedHandlesArray.length - 1) {
          break;
        }
      }

      if (arrayURLs.length > 0 && arrayURLs.length >= this.minimum) {
        this.container.classList.remove('hide');

        if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
          this.tabsHolderScroll.classList.remove('hide');
        }

        const fecthRequests = arrayURLs.map((url) => fetch(url, {mode: 'no-cors'}).then(this.handleErrors));
        const productMarkups = [];

        Promise.allSettled(fecthRequests)
          .then((responses) => {
            return Promise.all(
              responses.map(async (response) => {
                if (response.status === 'fulfilled') {
                  productMarkups.push(await response.value.text());
                }
              })
            );
          })
          .then(() => {
            productMarkups.forEach((markup) => {
              const buffer = document.createElement('div');
              const slide = document.createElement('div');
              buffer.innerHTML = markup;

              slide.classList.add('product-grid-slide');
              slide.innerHTML = buffer.querySelector(config.apiContent).innerHTML;

              this.wrapper.appendChild(slide);
            });
          })
          .then(() => {
            showElement(this.wrapper, true);

            this.container.dispatchEvent(new CustomEvent('recent-products:added', {bubbles: true}));
          });
      } else if (this.recentViewedTab) {
        const hasSiblingTabs =
          Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (child) => {
            return child !== this.recentViewedTab;
          }).length > 1;

        if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
          this.tabsHolderScroll.classList.add('hide');
        }

        if (!hasSiblingTabs) {
          this.container.classList.add('hide');
        }
      } else {
        this.container.classList.add('hide');
      }
    }
  }

  handleErrors(response) {
    if (!response.ok) {
      return response.text().then(function (text) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          text: text,
        });
        throw e;
      });
    }
    return response;
  }
}

class RecordRecentlyViewed {
  constructor(handle) {
    this.handle = handle;
    this.cookie = new Cookie(cookieConfig);

    if (typeof this.handle === 'undefined') {
      return;
    }

    excludedHandles.push(this.handle);

    this.updateCookie();
  }

  updateCookie() {
    let recentlyViewed = this.cookie.read();

    // In what position is that product in memory.
    const position = recentlyViewed.indexOf(this.handle);

    // If not in memory.
    if (position === -1) {
      // Add product at the start of the list.
      recentlyViewed.unshift(this.handle);
      // Only keep what we need.
      recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
    } else {
      // Remove the product and place it at start of list.
      recentlyViewed.splice(position, 1);
      recentlyViewed.unshift(this.handle);
    }

    // Update cookie.
    this.cookie.write(recentlyViewed);
  }
}

const recentProducts = {
  onLoad() {
    sections[this.id] = new RecentProducts(this);
  },
};

export {recentProducts, RecentProducts, RecordRecentlyViewed};
